import { MenuItem } from 'primeng/api/menuitem';
import { SelectItem } from 'primeng/api/selectitem';

import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';
import { RaceService } from 'src/app/services/race.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-type-race',
  templateUrl: './type-race.component.html',
  styleUrls: ['./type-race.component.scss'],
})
export class TypeRaceComponent implements OnInit {
  @Output() typeChange = new EventEmitter<string>();
  showModal: boolean = false;
  items: MenuItem[] = [];
  constructor(public appSettings: SettingsService, private raceService: RaceService, private cdr: ChangeDetectorRef, private authService: AuthService) { }

  ngOnInit() {
    this.appSettings.selectedLang$.subscribe(() => {
      this.rebuildDropDown();
    });
    this.rebuildDropDown();
  }

  rebuildDropDown() {
    this.items = [];

    this.appSettings.racesTypes.forEach((racesType) => {
      if (racesType.value != this.appSettings.selectedRacesType.label && racesType.label) {
        const label = this.appSettings.translate[this.appSettings.selectedLang][racesType.label];
        this.items.push({
          label,
          icon: racesType.icon,
          command: () => {
            this.changeType(racesType);
          },
        });
      }
    });
    this.cdr.detectChanges();
  }

  modalRacesTypeList() {
    this.showModal = !this.showModal;
  }

  changeType(selectType: SelectItem) {
    this.appSettings.selectedRacesType = selectType;
    this.typeChange.emit(selectType.value);
    this.rebuildDropDown();
    this.modalRacesTypeList();
    this.raceService.emptyRaceList();
    this.authService.refresh.next();
  }
}
